import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getInvitationOrder = async (token) => {
    const response = await axios.get(routes.getInvitationOrder(token), AXIOS_DEFAULT_CONFIG);
    return response;
};
export default getInvitationOrder;
